const stats = [
  { value: '92%', label: 'Improved Self-Awareness' },
  { value: '7.2x', label: 'Growth Rate' },
  { value: '120K', label: 'Assessments Completed' },
];

export function NLPImpact() {
  return (
    <section className="py-16 md:py-20 px-4 md:px-8 bg-nlp-forest">
      <div className="max-w-[1216px] mx-auto">
        <div className="text-center mb-12">
          <h2
            className="text-2xl md:text-3xl font-bold text-nlp-bg mb-2"
            style={{ fontFamily: 'Georgia, serif' }}
          >
            Our Impact So Far
          </h2>
          <p className="text-nlp-cream text-lg max-w-xl mx-auto">
            NLP OS is helping thousands discover their true potential and achieve
            breakthrough results in their personal and professional lives.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8 md:gap-12">
          {stats.map((stat, index) => (
            <div key={index} className="text-center">
              <p
                className="text-5xl md:text-6xl font-bold text-nlp-gold-light mb-2"
                style={{ fontFamily: 'Georgia, serif' }}
              >
                {stat.value}
              </p>
              <p className="text-nlp-cream font-medium">{stat.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
